import React from "react"
import './App.css'
import { Routes, Route } from "react-router-dom";
// import { useEffect } from "react";
// import { Rings } from "react-loader-spinner";

import './Pages/css/style.css'
import './Pages/css/spacing.css'
import './Pages/css/slick.css'
import './Pages/css/animate.css'
import './Pages/css/hover-reveal.css'
// import './Pages/css/font-awesome-pro.css'

import Home from "./Pages/Home.jsx";
import About from "./Pages/About";
import PricingPlan from "./Pages/PricingPlan";
import Faq from "./Pages/Faq";

function App() {

  // const Loader = () => {
  //   useEffect(() => {
  //     window.onload = () => {
  //       const preloader = document.querySelector(".preloader");
  //       preloader.remove();
  //     }
  //   });
  //   return <LoaderFile />
  //   which have your preloader html and having class is `.preloader`
  // };

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/pricingplan" element={<PricingPlan />} />
        <Route path="/faq" element={<Faq />} />
      </Routes>
    </>
  );
}

export default App;
